<script>

export default {
  name: 'LieuxDialog',

  props: {
    lignes: {
      type: Array,
      default: () => []
    },
    isError: {
      type: Boolean,
      default: false
    },
    isVide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _lignes () {
      return this.lignes.slice().sort((a, b) => {
        const aa = (a.numBatiment || '0') + '-' + [a.codeTypeSilo1, a.codeTypeSilo2, a.codeTypeSilo3].map(a => '' + (a || '')).sort((a, b) => a.localeCompare(b)).join('');
        const bb = (b.numBatiment || '0') + '-' + [b.codeTypeSilo1, b.codeTypeSilo2, b.codeTypeSilo3].map(a => '' + (a || '')).sort((a, b) => a.localeCompare(b)).join('');

        return aa.localeCompare(bb);
      });
    }
  }
};
</script>

<template>
  <div class="dialog-cnt">
    <header>
      <h2
        v-if="isError"
        class="error white--text"
      >
        Erreur
      </h2>
      <h2
        v-else
        class="warning"
      >
        Attention
      </h2>
    </header>

    <section>
      <div v-if="isError">
        Attention les aliments suivants concernent des espèces différentes et sont prévus d’être livrés dans les mêmes lieux de stockage:
      </div>
      <div v-else-if="isVide">
        Le lieu de stockage doit être renseigné pour chacune des lignes
      </div>
      <div v-else>
        Attention les aliments suivants sont prévus d’être livrés dans les mêmes lieux de stockage:
      </div>

      <ul>
        <li
          v-for="(ligne, index) in _lignes"
          :key="index"
        >
          <span>{{ ligne.libelleArticle }}</span>
          <!-- <span>Du {{ ligne.datePrevueLivraison | date }} au {{ ligne.finDatePrevueLivraison | date }}</span> -->
          <span v-if="ligne.numBatiment">{{ ligne.numBatiment }}</span>
          <span class="liste-lieux">
            <RefValue
              v-if="ligne.codeTypeSilo1"
              :code="ligne.codeTypeSilo1"
              type="TYPE_SILO"
            />
            <RefValue
              v-if="ligne.codeTypeSilo2"
              :code="ligne.codeTypeSilo2"
              type="TYPE_SILO"
            />
            <RefValue
              v-if="ligne.codeTypeSilo3"
              :code="ligne.codeTypeSilo3"
              type="TYPE_SILO"
            />
          </span>

          <span> {{ ligne.quantiteCommande | formatDecimal(3) }} {{ ligne.codeUniteArticle.toLowerCase() }}

          </span>
        </li>
      </ul>

      <div v-if="isError">
        Merci de modifier vos lignes de commande
      </div>
      <div v-else-if="isVide">
        Merci de renseigner un lieu de stockage
      </div>
      <div v-else>
        Voulez-vous vraiment confirmer ces dates et lieux de stockage ?
      </div>

      <div
        v-if="isError || isVide"
        class="actions"
      >
        <v-btn
          outlined
          @click="$emit('submit', false)"
        >
          OK
        </v-btn>
      </div>
      <div
        v-else
        class="actions"
      >
        <v-btn
          outlined
          @click="$emit('submit', false)"
        >
          Non
        </v-btn>
        <v-btn @click="$emit('submit', true)">
          Oui
        </v-btn>
      </div>
    </section>
  </div>
</template>
<style lang="scss" scoped>
.dialog-cnt {
  background-color: #f4f8f9;

  header h2 {
    padding: 0.8em 1.5em;
    font-weight: 400;
  }

  section {
    padding: 3em;

    & > *:not(:last-child) {
      margin-bottom: 1em;
    }
  }
}
.actions {
  margin-top: 2em;
  display: flex;
  justify-content: center;

  & > *:not(:last-child) {
    margin-right: 2em;
  }
}

li > span:not(:last-child) {
  &::after {
    content: "    -    ";
  }
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .dialog-cnt section {
    padding: 1em;
  }
}

.liste-lieux {
  & > *:not(:last-child) {
    margin-right: 5px;
    &::after {
      content: ",";
    }
  }
}
</style>
